import React, { FC } from 'react';
import Modal from '@material-ui/core/Modal';
import useStyles from './TopModal.styles';
import classNames from 'classnames';
import { Color } from '../../types';

export interface TopModalProps {
  topPosition?: number;
  dataQaId: string;
  children: React.ReactNode;
  open: boolean;
  color?: Color | 'tertiary';
  disableAutoFocus?: boolean;
  zIndex?: number;
  fixed?: boolean;
}

const TopModal: FC<TopModalProps> = ({
  children,
  dataQaId,
  open,
  color = 'primary',
  topPosition,
  disableAutoFocus = true,
  fixed = true,
  zIndex = 99,
}: TopModalProps) => {
  const classes = useStyles();
  return (
    <Modal
      open={open}
      disableScrollLock={true}
      hideBackdrop={true}
      disableEnforceFocus={true}
      disableAutoFocus={disableAutoFocus}
      className={classes.root}
      data-qa-id={`${dataQaId}-modal`}
      style={{
        top: topPosition ? `${topPosition}px` : '0px',
        bottom: 'auto',
        zIndex,
        position: fixed ? 'fixed' : 'absolute',
      }}
    >
      <div className={classNames(classes.content, classes[color])} data-qa-id={`${dataQaId}-content`}>
        {children}
      </div>
    </Modal>
  );
};

export default TopModal;
